// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-cbecc879","container":"container-b0b6ffe1","text":"text-cbd5ae96","children":"children-b17dd8f8"};